import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { shouldEnableLimitedModeForDocument } from '@atlaskit/editor-common/should-enable-limited-mode';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import type { EditorState, ReadonlyTransaction } from '@atlaskit/editor-prosemirror/state';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import type { LimitedModePluginState } from '../limitedModePluginType';

export const limitedModePluginKey: PluginKey = new PluginKey('limitedModePlugin');

type EditorStateConfig = Parameters<typeof EditorState.create>[0];

export const createPlugin = (): SafePlugin<LimitedModePluginState> => {
	return new SafePlugin<LimitedModePluginState>({
		key: limitedModePluginKey,
		view: (_view: EditorView) => {
			return {};
		},
		state: {
			init(_config: EditorStateConfig, editorState: EditorState) {
				return {
					documentSizeBreachesThreshold: shouldEnableLimitedModeForDocument(editorState.doc),
				};
			},
			apply: (
				tr: ReadonlyTransaction,
				currentPluginState: LimitedModePluginState,
				_oldState: EditorState,
				_newState: EditorState,
			) => {
				// Don't check the document size if we're already in limited mode.
				// We ALWAYS want to re-check the document size if we're replacing the document (e.g. live-to-live page navigation).

				if (currentPluginState.documentSizeBreachesThreshold && !tr.getMeta('replaceDocument')) {
					return currentPluginState;
				}

				return {
					documentSizeBreachesThreshold: shouldEnableLimitedModeForDocument(tr.doc),
				};
			},
		},
	});
};
